/**
 * Hook to get the user's default currency.
 * Returns user's preferred_currency if set, otherwise tenant's default_currency, otherwise 'USD'.
 */

import { useAuth } from '../auth';
import { useTenantLocaleSettings } from './useTenantSettings';

/**
 * Returns the user's effective default currency.
 * Priority: user.preferred_currency > tenant.default_currency > 'USD'
 */
export function useDefaultCurrency(): string {
  const { user } = useAuth();
  const { data: tenantSettings } = useTenantLocaleSettings();

  // User's preferred currency takes priority
  if (user?.preferred_currency) {
    return user.preferred_currency;
  }

  // Fall back to tenant's default currency
  if (tenantSettings?.default_currency) {
    return tenantSettings.default_currency;
  }

  // Final fallback
  return 'USD';
}
